import { createActions, createReducer } from "reduxsauce";

const initialState = {
  isLoading: false,

  page: 0,
  perPage: 10,
  search: {},

  data: [],
};

// Cria os action types e creators
export const { Types, Creators } = createActions({
  userChangePageRequest: ["page", "search"],
  userChangePageSuccess: ["data"],
  userChangePageFailure: ["data"],
});

// Criando os reducers handle
const userChangePageRequest = (state = initialState, action) => ({
  ...state,
  isLoading: true,
  page: action.page,
  perPage: action.perPage,
  error: null,
});

const userChangePageSuccess = (state = initialState, action) => ({
  ...state,
  isLoading: false,
  data: action.data,
});

const userChangePageFailure = (state = initialState, action) => ({
  ...state,
  isLoading: false,
  error: action.data,
});

// Criando reducer
export default createReducer(initialState, {
  [Types.USER_CHANGE_PAGE_REQUEST]: userChangePageRequest,
  [Types.USER_CHANGE_PAGE_SUCCESS]: userChangePageSuccess,
  [Types.USER_CHANGE_PAGE_FAILURE]: userChangePageFailure,
});
